export const OPS_ECOSYSTEM_RIGHTS = {
  desk1: "operations-desk-1-management",
  desk2: "operations-desk-2-management",
  desk3: "operations-desk-3-management",
  offers: "operations-whatsapp-offers-management",
};

export const OPS_ECOSYSTEM_RIGHT_KEYS = Object.values(OPS_ECOSYSTEM_RIGHTS);

const roleIsAdmin = (role) =>
  String(role || "")
    .trim()
    .toLowerCase() === "admin";

const rightIsOn = (rightsInfo, key) => rightsInfo?.[key] === true;

const hasFullOpsAccess = (rightsInfo, role) =>
  roleIsAdmin(role) || rightIsOn(rightsInfo, "operations-ecosystem-management");

export const getOpsEcosystemTabAccess = (rightsInfo = {}, role) => {
  const full = hasFullOpsAccess(rightsInfo, role);
  return {
    desk1: full || rightIsOn(rightsInfo, OPS_ECOSYSTEM_RIGHTS.desk1),
    desk2: full || rightIsOn(rightsInfo, OPS_ECOSYSTEM_RIGHTS.desk2),
    desk3: full || rightIsOn(rightsInfo, OPS_ECOSYSTEM_RIGHTS.desk3),
    offers: full || rightIsOn(rightsInfo, OPS_ECOSYSTEM_RIGHTS.offers),
  };
};

export const canAccessOpsEcosystem = (rightsInfo = {}, role) => {
  const access = getOpsEcosystemTabAccess(rightsInfo, role);
  return access.desk1 || access.desk2 || access.desk3 || access.offers;
};

export const canAccessPowerCustomerReturn = (rightsInfo = {}, role) =>
  roleIsAdmin(role) || rightIsOn(rightsInfo, "power-customer-return-management");
